exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-templates-content-hub-tsx": () => import("./../../../src/templates/content-hub.tsx" /* webpackChunkName: "component---src-templates-content-hub-tsx" */),
  "component---src-templates-home-tsx": () => import("./../../../src/templates/home.tsx" /* webpackChunkName: "component---src-templates-home-tsx" */),
  "component---src-templates-inquiry-tsx": () => import("./../../../src/templates/inquiry.tsx" /* webpackChunkName: "component---src-templates-inquiry-tsx" */),
  "component---src-templates-page-tsx": () => import("./../../../src/templates/page.tsx" /* webpackChunkName: "component---src-templates-page-tsx" */)
}

